module.exports = __webpack_public_path__ + "img/CM_logo.7c9d03c7.svg";